// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slice--column-content .inner p:last-child{margin-bottom:0}@media (min-width:48.0625em){.slice--column-content .row-md{margin:0 -1.40625rem}.slice--column-content .col{padding:0 1.40625rem}}@media (max-width:48.0525em){.slice--column-content .col{margin-bottom:1.875rem}.slice--column-content .col:last-child{margin-bottom:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
